import {UserInfoModel} from "app/model/ua/user-info";

export class UserInfoUtil {
  public static readonly ROLE_ADMIN = 'ADMIN';

  public static hasRole(userInfo: UserInfoModel, role: string) {
    if (!userInfo) {
      return false;
    }

    if (!role || role === '') {
      return true;
    }

    return (userInfo.auths?.filter(auth => auth.authNm === role).length ?? 0) > 0;
  }

  public static isAdmin(userInfo: UserInfoModel) {
    if (!userInfo) {
      return false;
    }

    return (userInfo.auths?.filter(auth => auth.authNm === this.ROLE_ADMIN).length ?? 0) > 0;
  }
}